import { useState } from 'react';
import { paletteList } from '@/pages/home/data';

function PaletteCard({ item }: { item: (typeof paletteList)[number] }) {
  const [saved, setSaved] = useState(false);
  return (
    <div className="group flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-colors hover:border-primary-300">
      <div className="relative h-36 w-full overflow-hidden bg-background-200">
        <img
          src={item.img}
          alt={`黑料色${item.name}配色方案`}
          className="h-full w-full object-cover"
        />
        <span className="absolute left-2.5 top-2.5 flex h-6 items-center whitespace-nowrap rounded-full bg-foreground-950/85 px-2.5 text-xs font-semibold text-background-50">
          {item.scene}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center justify-between gap-2">
          <h3 className="truncate font-display text-base font-bold text-foreground-950">
            {item.name}
          </h3>
          <span className="shrink-0 text-xs text-foreground-500">{item.tone}</span>
        </div>

        <div className="mt-3 flex flex-col gap-1">
          <div className="flex h-9 w-full overflow-hidden rounded-md border border-background-200">
            {item.colors.map((c) => (
              <div key={c} className="relative flex-1 cursor-pointer group/hex" title={c}>
                <div className="h-full w-full transition-opacity hover:opacity-80" style={{ backgroundColor: c }} />
                <span className="pointer-events-none absolute -top-0 left-1/2 z-10 hidden -translate-x-1/2 -translate-y-full whitespace-nowrap rounded bg-foreground-950 px-1.5 py-0.5 text-[10px] font-medium uppercase text-background-50 group-hover/hex:block">
                  {c}
                </span>
              </div>
            ))}
          </div>
          <div className="flex justify-between text-[10px] font-medium uppercase text-foreground-400">
            <span>暖调</span>
            <span>暗部</span>
            <span>主色</span>
            <span>提亮</span>
            <span>纸底</span>
          </div>
        </div>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {item.tags.map((t) => (
            <span
              key={t}
              className="flex h-6 cursor-pointer items-center whitespace-nowrap rounded-full bg-secondary-100 px-2.5 text-xs text-secondary-800"
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-3 flex items-center justify-between border-t border-background-300/60 pt-3">
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-fire-fill text-[13px] text-accent-500" />
            热度 {item.heat}
          </span>
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-400">{item.colors.length} 色</span>
            <button
              type="button"
              onClick={() => setSaved((v) => !v)}
              className={`flex h-8 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-xs font-medium transition-colors ${
                saved
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700'
              }`}
            >
              <i className={saved ? 'ri-bookmark-fill' : 'ri-bookmark-line'} />
              {saved ? '已存' : '收藏'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function PaletteGrid() {
  return (
    <section id="palette" className="scroll-mt bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-widest text-secondary-600">
              <span className="font-display text-sm font-black text-primary-500">02</span>
              <span className="h-px w-6 bg-background-400" />
              海报配色卡
            </div>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              海报配色方案，五色一套直接抄
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            每张卡从暗部到纸底给你排好五色与调色倾向，点色块看色号，看中一键收藏，配色直接套用不纠结。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {paletteList.map((p) => (
            <PaletteCard key={p.id} item={p} />
          ))}
        </div>
      </div>
    </section>
  );
}